<template>
    <Layout :style="{ minHeight: bodyHeight }">
        <Sider hide-trigger collapsible :collapsed-width="78" style="width: 255px;min-width: 255px;">
            <div class="side-logo" >
                <img  src="@assets/img/newlogo.png" alt="云展台" @click="$router.push('/host/project')" class="f-csp" />
               
                <!-- <span style="font-size: 16px;font-weight: 600;"> </span> -->
            </div>
            <gSide :siderArr="siderArr"></gSide>
        </Sider>
        <Layout style="height: 100%;width:calc(100% - 255px);" :style="{ minHeight: bodyHeight }">
            <Header :style="{ padding: 0 }" class="layout-header-bar">
                <gHead></gHead>
            </Header>
            <Content>
                <div :style="{ minHeight: '500px' }">
                    <router-view />
                </div>
            </Content>
            <Footer>
                <copyright />
            </Footer>
        </Layout>
    </Layout>
</template>

<script>
import gHead from "@components/gHead/gHead";
import gSide from "@components/gSide/gSide";
import copyright from "@components/copyright/copyright";
export default {
    name: "host-layout",
    data () {
        return {
            bodyHeight: "800px",
            siderArr: [
                {
                    title: "首页",
                    icon: "icon-shouye11",
                    router: "/host/index/home",
                    type: 1
                },

                {
                    title: "展商管理",
                    icon: "el-icon-data-analysis",
                    router: "/host/index/order",
                    type: 1
                },

                {
                    title: "参展申请",
                    icon: "el-icon-edit-outline",
                    router: "/host/index/apply",
                    type: 1
                },

                {
                    title: "统计",
                    icon: "el-icon-pie-chart",
                    router: "/host/index/census",
                    type: 1
                },



                // {
                //   title: "供需审核",
                //   icon: "icon-workplace-nav-audit",
                //   type: 2,
                //   children: [
                //     {
                //       title: "企业供需审核",
                //       router: "/host/index/supply/company"
                //     },
                //     {
                //       title: "用户供需审核",
                //       router: "/host/index/supply/user"
                //     },
                //     {
                //       title: "采买供需",
                //       router: "/host/index/supply/buySupply"
                //     },
                //   ]
                // },
                // {
                //   title: "供需信息",
                //   icon: "icon-workplace-nav-audit",
                //   type: 2,
                //   children: [
                //     {
                //       title: "企业供需信息",
                //       router: "/host/index/supply-info/company"
                //     },
                //     {
                //       title: "用户供需信息",
                //       router: "/host/index/supply-info/user"
                //     },
                //     {
                //       title: "商机供需",
                //       router: "/host/index/supply-info/business-opportunity"
                //     },
                // {
                //   title: "商机供需",
                //   router: "/host/index/supply-info/business-opportunity-detail"
                // },
                //   ]
                // },
                {
                    title: "填报管理",
                    icon: "el-icon-collection",
                    type: 2,
                    children: [
                        {
                            title: "会刊管理",
                            router: "/host/index/report/list"
                        },
                        {
                            title: "展品信息管理",
                            router: "/host/index/report/list2"
                        },
                        {
                            title: "楣板信息管理",
                            router: "/host/index/report/list3"
                        },
                        {
                            title: "展商胸卡管理",
                            router: "/host/index/report/list4"
                        },
                        {
                            title: "会刊广告管理",
                            router: "/host/index/report/list5"
                        },
                        {
                            title: "标展搭建变更管理",
                            router: "/host/index/report/list6"
                        },
                        {
                            title: "租凭管理",
                            router: "/host/index/report/list7"
                        },
                        {
                            title: "展台拆除/安装管理",
                            router: "/host/index/report/list8"
                        },
                        {
                            title: "回执表管理",
                            router: "/host/index/report/list9"
                        },

                    ]
                },
                {
                    title: "设置",
                    icon: "el-icon-setting",
                    type: 2,
                    children: [
                        {
                            title: "表单设置",
                            router: "/host/index/setting/list"
                        },
                        {
                            title: "回执表设置",
                            router: "/host/index/setting/list2"
                        },
                        {
                            title: "项目管理",
                            router: "/host/index/setting/list3"
                        }
                    ]
                },
                {
                    title: "数据维护",
                    icon: "el-icon-postcard",
                    type: 1,
                    router: "/host/index/hostdate",
                    // router: "/host/index/census",

                },

                // {
                //   title: "审核",
                //   icon: "icon-dengji1",
                //   type: 2,
                //   children: [
                //     {
                //       title: "展商审核",
                //       router: "/host/index/audit/list"
                //     },
                //     // {
                //     //   title: "动态审核",
                //     //   router: "/host/index/audit/news"
                //     // },
                //   ]
                // },
                // {
                //   title: "管理",
                //   icon: "icon-leimupinleifenleileibie",
                //   type: 2,
                //   children: [
                //     {
                //       title: "展商管理",
                //       router: "/host/index/ex/list"
                //     },
                //     // {
                //     //   title: "展品",
                //     //   router: "/host/index/pro/pro-home"
                //     // },
                //     // {
                //     //   title: "活动",
                //     //   router: "/host/index/act/act-home"
                //     // },
                //     // {
                //     //   title: "用户",
                //     //   router: "/host/index/ex/user"
                //     // },
                //     {
                //       title: "参展申请",
                //       router: "/host/index/ex/applyEx"
                //     },
                //     {
                //       title: "需求表管理",
                //       router: "/host/index/Exneed"
                //     },
                //     // {
                //     //   title: "展团申请",
                //     //   router: "/host/index/ex/pavilion"
                //     // },
                //     // {
                //     //   title: "证件申请",
                //     //   router: "/host/index/ex/cert"
                //     // },
                //     // {
                //     //   title: "实名验证",
                //     //   router: "/host/index/pro/id-check"
                //     // },
                //     // {
                //     //   title: "车证管理",
                //     //   router: "/host/index/carmanage/carmanage-home"
                //     // },
                //     // {
                //     //   title: "关键字",
                //     //   router: "/host/index/set/Search"
                //     // },
                //     // {
                //     //   title: "洽谈统计",
                //     //   router: "/host/index/set/Statistics"
                //     // },
                //     // {
                //     //   title: "渠道统计",
                //     //   router: "/host/index/set/Channel"
                //     // },

                //   ]
                // },
                // {
                //   title: "展会设置",
                //   icon: "icon-zhanhuiguanli",
                //   type: 2,
                //   children: [
                //     {
                //       title: "基础设置",
                //       router: "/host/index/set/base"
                //     },
                //     // {
                //     //   title: "类别扩展",
                //     //   router: "/host/index/set/classify"
                //     // },
                //     {
                //       title: "完成项设置",
                //       router: "/host/index/set/project"
                //     },
                //     // {
                //     //   title: "广告管理",
                //     //   router: "/host/index/common/common-ad"
                //     // },
                //     {
                //       title: "下载管理",
                //       router: "/host/index/common/common-down"
                //     },
                //     {
                //       title: "需求表设置",
                //       router: "/host/index/need"
                //     },
                //     // {
                //     //   title: "注意事项",
                //     //   router: "/host/index/common/common-tip"
                //     // },
                //     // {
                //     //   title: "联系人",
                //     //   router: "/host/index/common/common-contact"
                //     // },
                //     // {
                //     //   title: "订单设置",
                //     //   router: "/host/index/set/ExServices"
                //     // },
                //     // {
                //     //   title: "行业动态",
                //     //   router: "/host/index/set/news"
                //     // },
                //     // {
                //     //   title: "企业动态",
                //     //   router: "/host/index/set/Exnews"
                //     // },
                //     // {
                //     //   title: "会议管理",
                //     //   router: "/host/index/set/Meeting"
                //     // }
                //     // {
                //     //   title: "展会计划",
                //     //   router: "/host/index/set/plan"
                //     // }
                //   ]
                // },
                // {
                //   title: "通用设置",
                //   icon: "icon-shezhi1",
                //   type: 2,
                //   children: [
                //     // {
                //     //   title: "云店标签",
                //     //   router: "/host/index/common/common-label"
                //     // },
                //     {
                //       title: "区域设置",
                //       router: "/host/index/common/common-region"
                //     },
                //     {
                //       title: "国家设置",
                //       router: "/host/index/common/common-country"
                //     },
                //     {
                //       title: "省市设置",
                //       router: "/host/index/common/common-city"
                //     },
                //     // {
                //     //   title: "功能管理",
                //     //   router: "/host/index/common/common-function"
                //     // },
                //     // {
                //     //   title: "条码规则",
                //     //   router: "/host/index/common/common-barcode"
                //     // },
                //     // {
                //     //   title: "海报分享模板",
                //     //   router: "/host/index/common/common-poster"
                //     // },
                //     // {
                //     //   title: "短信模板",
                //     //   router: "/host/index/common/common-message"
                //     // },
                //     // {
                //     //   title: "文字分享模板",
                //     //   router: "/host/index/common/common-text"
                //     // },
                //     // {
                //     //   title: "问券调查",
                //     //   router: "/host/index/common/common-question"
                //     // },
                //   ]
                // },
                // {
                //   title: "网站设置",
                //   icon: "icon-shezhi1",
                //   type: 2,
                //   children: [
                //     {
                //       title: "广告管理",
                //       router: "/host/index/webSet/webBanner"
                //     },
                //     // {
                //     //   title: "快捷入口",
                //     //   router: "/host/index/webSet/web-entrance"
                //     // },
                //     {
                //       title: "热搜产品",
                //       router: "/host/index/webSet/web-hotpro"
                //     },
                //     {
                //       title: "活动信息",
                //       router: "/host/index/webSet/webMarathon"
                //     },
                //     {
                //       title: "联系我们",
                //       router: "/host/index/webSet/web-service"
                //     },
                //     {
                //       title: "展会计划",
                //       router: "/host/index/webSet/web-plan"
                //     },
                //     {
                //       title: "邮箱配置",
                //       router: "/host/index/webSet/web-email"
                //     },
                //   ]
                // },
                // {
                //   title: "展位预定信息",
                //   icon: "icon-shezhi1",
                //   type: 2,
                //   children: [
                //     {
                //       title: "信息导出",
                //       router: "/host/index/exInformation/exInformation-home"
                //     },

                //   ]
                // },
            ]
        };
    },
    components: {
        gHead,
        gSide,
        copyright
    },
    computed: {},
    created () {
        this.bodyHeight = window.innerHeight ? window.innerHeight + 'px' : '800px';
    }
};
</script>

<style lang="scss">
body {
    padding-right: 0 !important;
}
</style>
<style scoped lang='scss'>
.layout-header-bar {
    background: #fff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.side-logo {
    text-align: center;
    height: 64px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        height: 35px;
        max-width: 98%;
        max-height: 98%;
    }
}
</style>
